<template>
  <div>
    <MainPlayer
      v-if="contentInfo && currentSection"
      :content-info="contentInfo"
      :current-section="currentSection"
      :content-type="contentType"
    />
    <PpvToast />
  </div>
</template>

<script>
  import { get } from 'lodash'
  import MainPlayer from '@/components/player/MainPlayer'
  import { ATTR_BY_PLAYER_TYPE, PLAYER_TYPE } from '@/common/utils/player.util'
  import streamPageMixin from '@/mixins/stream.page.mixin'
  import PpvToast from '@/components/movie/PpvToast'
  import { removeFadeOutBody } from '@/common/utils/common'
  import {
    showLoginPopup,
    showVoucherPopup,
  } from '@/common/utils/scalable.player'
  import cookie from '@/common/utils/cookie'

  /**
   * 아폴로 플레이어 페이지
   * dom은 없고 플레이어만 꽉찬 형태
   * 기존 MobilePlayer에 동일한 형태의 데이터 내려주기 위해 한번 감쌈
   */
  export default {
    components: {
      MainPlayer,
      PpvToast,
    },
    mixins: [streamPageMixin],
    data() {
      return {
        contentInfo: {},
        currentSection: '',
      }
    },
    computed: {
      contentType() {
        let _contentType = this.currentSection
        switch (this.currentSection) {
          case 'vod':
            _contentType =
              this.contentInfo.type === 'onair'
                ? PLAYER_TYPE.ONAIRVOD
                : PLAYER_TYPE.VOD
            break
          case 'baseball':
            _contentType = 'baseball'
            break
        }
        return _contentType
      },
    },
    watch: {
      $route(n, o) {
        this.initialize()
      },
    },
    mounted() {
      this.initialize()
      window.showLoginLayout = showLoginPopup
    },
    methods: {
      initialize() {
        removeFadeOutBody()
        // section(vod, movie)와 콘텐츠id가 없으면 에러로 라우터 back
        if (
          !this.$route.params.section ||
          this.$route.params.section === '' ||
          !get(
            this.$route.query,
            ATTR_BY_PLAYER_TYPE[this.$route.params.section].id,
          )
        ) {
          this.$events.$emit(
            'OPEN_PPV_TOAST',
            () => {
              this.$router.back()
            },
            '해당 컨텐츠가 없습니다.',
          )
          return
        }
        this.currentSection = this.$route.params.section
        const newContentInfo = {}
        newContentInfo[ATTR_BY_PLAYER_TYPE[this.currentSection].id] = get(
          this.$route.query,
          ATTR_BY_PLAYER_TYPE[this.currentSection].id,
        )
        this.contentInfo = newContentInfo
        this.setPlayerEvent()
      },
      setPlayerEvent() {
        window.showLoginLayout = showLoginPopup
        window.showVoucherPopup = showVoucherPopup // 이용권 팝업
        window.showEventVoucherPopup = () => {
          window.open(
            '/voucher/popup?type=all',
            '',
            'width=700, height=780, scrollbars=yes',
          )
        } // 이벤트 이용권 팝업
        window.isVerifiedAdultUser = cookie.isVerifiedAdultUser.bind(cookie)
      },
    },
  }
</script>
